// extracted by mini-css-extract-plugin
export var container = "FooterSocials-module--container--d13fd";
export var iconListWrapper = "FooterSocials-module--iconListWrapper--095e2";
export var text = "FooterSocials-module--text--f5ae4";